/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_text.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value into text.
 *
 * @example
 * ROW a = ["this", "is", "a", "text"]
 * | EVAL text_a = TO_TEXT(a)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_text',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'text',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'text',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
